const B_1 = [
    {
        title: '工作台',
        path: '/bidding/workbench/index'
    }
]

export default {
    path: '',
    component: () => import(/*webpackChunkName: 'workbench'*/ '@layout/empty'),
    children: [
        {
            path:"index",
            component: () => import(/*webpackChunkName: 'workbench'*/'@views/bidding/views/workbench/index'),
            meta: {
                title: '工作台',
                topNav: true,
                bread: B_1
            },
        }
    ]
}
